<template>
    <div class="pop-out__backdrop" v-show="open" @click="close">
        <div @click.stop class="pop-out__container pop-out__container--card">
            <slot name="image" v-if="showImage"></slot>
            <div class="pop-out__inner">
                <div class="pop-out__content pop-out__header" v-if="showHeader">
                    <slot name="header"></slot>
                </div>

                <div class="pop-out__content pop-out__body" v-if="showBody">
                    <slot name="body"></slot>
                </div>

                <slot></slot>

                <div class="pop-out__content pop-out__buttons" v-if="showButtons">
                    <slot name="buttons"></slot>
                </div>

                <div class="pop-out__content pop-out__footer" v-if="showFooter">
                    <slot name="footer"></slot>
                </div>

            </div>

            <img v-if="showCloseIcon" src="/images/used/close-icon.svg" :class="{ 'pop-out__close-icon': true, 'pop-out__close-icon--background': closeHasBackground }" alt="Close" @click="dismissModal" />
        </div>
        <div class="pop-out__triangle"></div>
    </div>
</template>

<script>
const bodyScrollLock = require('body-scroll-lock');

export default {
    props: {
        open: {
            type: Boolean,
            required: true,
            default: false
        },
        narrow: {
            type: Boolean,
            required: false,
            default: true
        },
        isCard: {
            type: Boolean,
            required: false,
            default: false
        },
        isDismissedOnClickBackdrop: {
            type: Boolean,
            required: false,
            default: true
        },
        borderTop: {
            type: Boolean,
            required: false,
            default: true
        },
        showCloseIcon: {
            type: Boolean,
            required: false,
            default: false
        },
        closeHasBackground: {
            type: Boolean,
            required: false,
            default: false
        },
        formType: {
            type: String,
            default: 'osb',
        },

    },
    data() {
        return {
            showImage: false,
            showHeader: false,
            showBody: false,
            showButtons: false,
            showFooter: false,
            top: 0,
            left: 0,
        }
    },

    methods: {
        close() {
            if (this.isDismissedOnClickBackdrop === true) {
                this.$emit('close');
            }
        },
        dismissModal() {
            this.$emit('close');
        },
        setShowSlots() {
            this.showImage = this.$slots.image?.[0]
            this.showHeader = this.$slots.header?.[0]
            this.showBody = this.$slots.body?.[0]
            this.showButtons = this.$slots.buttons?.[0]
            this.showFooter = this.$slots.footer?.[0]
        }
    },
    created() {
        if (this.containerTop != 0) {
            this.top = this.containerTop

        }
        if (this.containerLeft != 0) {
            this.left = this.containerLeft

        }
    },
    created() {
        this.setShowSlots();
    },
    beforeUpdate() {
        this.setShowSlots();
    },
    beforeDestroy() {
        bodyScrollLock.enableBodyScroll(this.$refs['scrollableArea']);
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// resources/assets/js/core/components/PopOut.vue